export default __webpack_public_path__ + "static/media/message.495e2648.svg";